import { render, staticRenderFns } from "./TrafficRenderer.vue?vue&type=template&id=45e3036d&"
import script from "./TrafficRenderer.vue?vue&type=script&lang=js&"
export * from "./TrafficRenderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports